import React from "react";
import { Link, Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import {
    Breadcrumb,
    Card,
    Row,
    Col,
    Avatar,
    Form,
    Input,
    Button,
    Space,
    Select,
    DatePicker,
    message,
    Alert,
    Spin,
    Modal,
    Skeleton,
    Table,
    Tabs,
    Result,
} from "antd";
import {
    DiffOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    DollarOutlined,
    BarcodeOutlined,
    UserAddOutlined,
    PrinterOutlined,
    UserOutlined,
    WarningOutlined,
    SaveOutlined,
    FileSearchOutlined,
    ExclamationCircleOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import moment from "moment";
import NumberFormat from "react-number-format";

import axios from "axios";
import Config from "../../Config";

import { connect } from "react-redux";
import {
    initHandler,
    ajaxViewHandler,
    ajaxHandler,
    setConfig,
} from "../../store/actions";
import { Helmet } from "react-helmet";

const FormItem = Form.Item;

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 19,
            offset: 5,
        },
        lg: {
            span: 19,
            offset: 5,
        },
    },
};

const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
};
const tailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};

const configClass = {
    apiUrl: {
        produk: "master/api/produk",
        detail_transaksi: "pasien/api/gambar/",
        dosis: "master/api/dosis",
        racikan: "master/api/racikan",
        aturan_makan: "master/api/aturan/makan/",
        waktu: "master/api/waktu/"
    },
    pageUrl: {
        cetak_resep: "/addon/cetak_resep/",
    },
};

const config = new Config();

class Foto extends React.Component {
    formRefFoto = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            loadingData: false,
            pagination: { pageSize: 25 },
            searchText: '',
            searchColumn: '',
            dataSource: [],
            columns: [
                {
                    title: 'FOTO',
                    width: 200,
                    dataIndex: 'gambar',
                    key: 'gambar',
                    render: (value, row, index) => {
                        return value != null && 
                            <a href={value} target="_blank">
                                <img src={value} alt="image error" width="80" height="80" style={{ objectFit: 'cover' }} />
                            </a>
                    }
                },
                {
                    title: 'CREATED',
                    width: 200,
                    dataIndex: 'created_at',
                    key: 'created_at',
                    render: (value, row, index) => {
                        return moment(value).format("DD-MM-YYYY HH:mm")
                    }
                },
            ],

            gambar: null,
            errComponent: false,
            errTitle: "",
            errMsg: "",
            loadingButton: false,

            jenis_layanan: "produk",

            loadingObat: false,
            listObat: [],

            loadingDosis: false,
            listDosis: [],

            loadingCarikan: false,
            listRacikan: [],

            loadingCarObat: false,
            cartObat: [],

            loadingAturanMakan: false,
            listAturanMakan: [],

            loadingWaktu: false,
            listWaktu: [],

            loadingBarcodeObat: false,
            barcodeObatIsNotFound: false,
            barcodeObatResults: null,

            totalObat: 0,
            total_finalObat: 0,
            barcodeTextObat: undefined,

            loadingSimpanFoto: false,

            isFinish: false,
            dosis: null,
            keterangan: null,
            dosis_nama: null,
            racikan: null,
            racikan_nama: null,
            aturan_makan: null,
            waktu: null,

            isValid: false,
            // isValidAturanMakan: false,
            // isValidWaktu: false,

            tempKodeBarcode: null,
            tempIdProduk: null,

            method: "post",
        };
    }

    UNSAFE_componentWillMount() {
        this.props.initHandler();
    }

    componentDidMount() {
        // this.loadMasterList();
        if (
            this.props.transaksi != null &&
            this.props.transaksi[0].pasien != null 
        ) {
            this.getData();
        }
    }

    componentDidUpdate(prevProps) {
        // console.log('prevprops', prevProps.transaksi);
        // console.log('newProps', this.props.transaksi);
        // alert(prevProps.transaksi);
        if (
            JSON.stringify(prevProps.transaksi) !=
            JSON.stringify(this.props.transaksi)
        ) {
            this.reset();
            if (
                this.props.transaksi != null &&
                this.props.transaksi[0].pasien != null
            ) {
                this.getData();
            }
        }
    }

    loadMasterList() {
        const rule = [
            {
                destination: {
                    stateProgressName: "loadingObat",
                    endPoint: configClass.apiUrl.produk + "?tipe=2",
                    stateDestination: "listObat",
                },
                nextDestination: {
                    stateProgressName: "loadingDosis",
                    endPoint: configClass.apiUrl.dosis,
                    stateDestination: "listDosis",
                    next: null,
                },
            },
            {
                destination: {
                    stateProgressName: "loadingRacikan",
                    endPoint: configClass.apiUrl.racikan,
                    stateDestination: "listRacikan",
                },
                nextDestination: null,
            },
            {
                destination: {
                    stateProgressName: "loadingAturanMakan",
                    endPoint: configClass.apiUrl.aturan_makan,
                    stateDestination: "listAturanMakan",
                },
                nextDestination: {
                    stateProgressName: "loadingWaktu",
                    endPoint: configClass.apiUrl.waktu,
                    stateDestination: "listWaktu",
                    next: null,
                },
            },
            {
                destination: {
                    stateProgressName: "loadingRacikan",
                    endPoint: configClass.apiUrl.racikan,
                    stateDestination: "listRacikan",
                },
                nextDestination: null,
            },
        ];

        this.setState({
            errComponent: false,
        });

        rule.map((item, index) => {
            if (index == rule.length - 1) {
                this.getMasterList(item, true);
            } else {
                this.getMasterList(item);
            }
        });
    }

    async getMasterList(rule, isFinal = false) {
        var destination = rule.destination;
        var nextDestination = rule.nextDestination;
        this.setState({ [destination.stateProgressName]: true });
        this.props
            .ajaxViewHandler("get", destination.endPoint)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    if (data.count != undefined) {
                        let newState = null;
                        if (this.state[destination.stateDestination].length == 0) {
                            newState = data;
                        } else {
                            if (destination.stateProgressName.includes("_searching")) {
                                newState = data;
                            } else {
                                const oldState = this.state[destination.stateDestination];
                                newState = {
                                    count: data.count,
                                    next: data.next,
                                    previous: data.previous,
                                    results: [...oldState.results, ...data.results],
                                };
                            }
                        }
                        this.setState({
                            [destination.stateDestination]: newState,
                        });
                    } else if (data.results != undefined) {
                        this.setState({
                            [destination.stateDestination]: data.results,
                        });
                    } else {
                        if (Array.isArray(data)) {
                            this.setState({
                                [destination.stateDestination]: data,
                            });
                        } else {
                            this.setState({
                                [destination.stateDestination]: [data],
                            });
                        }
                    }
                } else {
                    this.setState({
                        errComponent: true,
                    });
                }
                this.setState({ [destination.stateProgressName]: false });
            })
            .catch((response) => {
                console.log("gagal_get_master", response);
                message.error({
                    content: "gagal request data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
                this.setState({
                    errTitle: "gagal request data master",
                    errMsg: response,
                });
                this.setState({ [destination.stateProgressName]: false });
            });
        //next function
        if (nextDestination != null) {
            const next = {
                destination: {
                    stateProgressName: nextDestination.stateProgressName,
                    endPoint: nextDestination.endPoint,
                    stateDestination: nextDestination.stateDestination,
                },
                nextDestination: nextDestination.next,
            };
            this.getMasterList(next);
        }
    }

    generateSelect(stateName, url, key, value) {
        return this.state["loading" + stateName] ? (
            <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
        ) : (
            <Select
                labelInValue
                showSearch
                placeholder={"Pilih " + stateName}
                optionFilterProp="children"
                onSearch={(val) => {
                    const rule = {
                        destination: {
                            stateProgressName: "loading" + stateName + "_searching",
                            endPoint: url + "?search=" + val,
                            stateDestination: "list" + stateName,
                        },
                        nextDestination: null,
                    };
                    this.getMasterList(rule);
                }}
                onPopupScroll={(e) => {
                    e.persist();
                    let target = e.target;
                    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
                        if (
                            this.state["list" + stateName].next != undefined &&
                            this.state["list" + stateName].next != null
                        ) {
                            const rule = {
                                destination: {
                                    stateProgressName: "loading" + stateName + "Paging",
                                    endPoint: this.state["list" + stateName].next,
                                    stateDestination: "list" + stateName,
                                },
                                nextDestination: null,
                            };
                            this.getMasterList(rule);
                        }
                    }
                }}
                allowClear
                size={"large"}
                onChange={(val) => {
                    // console.log('obat_val', val.value)
                    if (stateName == "Racikan") {
                        console.log('racikane', val);
                        this.formRefFoto.current.setFieldsValue({
                            keterangan: undefined,
                            dosis: undefined,
                            aturan_makan: undefined,
                            waktu: undefined,
                        });
                        this.setState({
                            racikan: val != undefined ? val.value : '',
                            racikan_nama: val != undefined ? val.label : '',
                            dosis: null,
                            keterangan: null,
                            dosis_nama: null,
                            aturan_makan: null,
                            waktu: null,
                        });
                    }
                    // if(this.state.isValid == true && this.state.isValidWaktu == true && this.state.isValidAturanMakan == true){
                    //   this.pilihObat(val);
                    // }
                }}
            >
                {this.state["loading_" + stateName + "_searching"] && (
                    <Select.Option value="">
                        <Spin size="small" />
                    </Select.Option>
                )}
                {this.state["list" + stateName].count != undefined
                    ? this.state["list" + stateName].results.map((item) => (
                        <Select.Option value={item[key]}>
                            {item[value] + ""}
                        </Select.Option>
                    ))
                    : this.state["list" + stateName].map((item) => (
                        <Select.Option value={item[key]}>
                            {item[value] + ""}
                        </Select.Option>
                    ))}
                {this.state["list" + stateName] != undefined &&
                    this.state["list" + stateName].next != undefined && (
                        <Select.Option value="">
                            <Spin size="small" />
                        </Select.Option>
                    )}
            </Select>
        );
    }

    generateSelectProdukObat(stateName, url, key, value) {
        return this.state["loading" + stateName] ? (
            <img src={process.env.PUBLIC_URL + "/loading_crop.gif"} height="50" />
        ) : (
            <Select
                autoFocus
                showSearch
                placeholder={"cari / pilih " + stateName.toLowerCase()}
                optionFilterProp="children"
                onSearch={(val) => {
                    const rule = {
                        destination: {
                            stateProgressName: "loading" + stateName + "_searching",
                            endPoint: url + "&search=" + val,
                            stateDestination: "list" + stateName,
                        },
                        nextDestination: null,
                    };
                    this.getMasterList(rule);
                }}
                onPopupScroll={(e) => {
                    e.persist();
                    let target = e.target;
                    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
                        if (
                            this.state["list" + stateName].next != undefined &&
                            this.state["list" + stateName].next != null
                        ) {
                            const rule = {
                                destination: {
                                    stateProgressName: "loading" + stateName + "Paging",
                                    endPoint: this.state["list" + stateName].next,
                                    stateDestination: "list" + stateName,
                                },
                                nextDestination: null,
                            };
                            this.getMasterList(rule);
                        }
                    }
                }}
                allowClear
                style={{
                    width: "100%",
                }}
                size={"large"}
                onChange={(val) => {
                    if (stateName == "Obat" && val != '' && val != undefined && val != null) {
                        this.setState({
                            isValid: true,
                            tempIdProduk: val
                        });
                        // if(this.state.isValid){
                        //   this.setState({
                        //     tempIdProduk: val
                        //   }, () =>{
                        //     this.pilihObat(val);
                        //   });
                        // }else{
                        //   this.setState({
                        //     tempIdProduk: val
                        //   });
                        // }
                    }
                }}
            >
                {this.state["loading" + stateName + "_searching"] == true && (
                    <Select.Option value="">
                        <Spin size="small" />
                    </Select.Option>
                )}
                {this.state["list" + stateName].count != undefined
                    ? this.state["list" + stateName].results.map((item) => (
                        <Select.Option value={item[key] + ""}>
                            {item[value]}
                        </Select.Option>
                    ))
                    : this.state["list" + stateName].map((item) => (
                        <Select.Option value={item[key] + ""}>
                            {item[value]}
                        </Select.Option>
                    ))}
                {this.state["list" + stateName] != undefined &&
                    this.state["list" + stateName].next != undefined && (
                        <Select.Option value="">
                            <Spin size="small" />
                        </Select.Option>
                    )}
            </Select>
        );
    }

    async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
        this.setState({ loadingData: true });
        //console.log('master/api/desa/?limit='+limit+'&offset='+offset);

        this.props.ajaxViewHandler('get', configClass.apiUrl.detail_transaksi + '?pasien_id=' + this.props.transaksi[0].pasien + "&limit="+limit + '&offset=' + offset + '&search=' + search)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pagination = { ...this.state.pagination };
                    pagination.total = data.count;
                    this.setState({
                        dataSource: data.results,
                        pagination
                    });
                } else {
                    const errTitle = 'error get data';
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg
                    });
                    message.error({ content: errTitle, duration: 2, key: 'toast' });
                }
                this.setState({ loadingData: false });
            }).catch((response) => {
                console.log('gagal_get_preview', response);
                message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
                this.setState({ loadingData: false });
            });
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pagination };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingData: true,
            pagination
        });
        if (pagination.current == 1) {
            this.getData(pagination.pageSize);
        } else {
            this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
        }


    }

    async getDosis(idDosis) {
        // this.setState({loadingBarcode: true});
        //console.log('master/api/desa/?limit='+limit+'&offset='+offset);

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.dosis + "/" + idDosis)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    if (data != undefined && data != null) {
                        this.setState({
                            dosis_nama: data.nama,
                        });
                    }
                }
            })
            .catch((response) => {
                console.log("gagal_dosis", response);
                message.error({
                    content: "gagal request data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
            });
    }

    setGambar = (e) => {
        this.setState({
            'gambar': e.target.files[0]
        });
    }

    async scanObat(barcode) {
        // this.setState({loadingBarcode: true});
        //console.log('master/api/desa/?limit='+limit+'&offset='+offset);

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.produk + "?barcode=" + barcode)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    if (data.results.length > 0) {
                        this.setState(
                            {
                                barcodeObatIsNotFound: false,
                                barcodeObatResults: data.results,
                                loadingBarcodeObat: false,
                            },
                            () => {
                                let temp_cart = this.state.cartObat;
                                // let temp_label_produk = this.state.label_produk;
                                let that = this;
                                if (temp_cart.length == 0) {
                                    let produk = this.state.barcodeObatResults[0];
                                    // let harga = 0;
                                    // let diskon_rupiah = 0;
                                    // if(produk['diskon']!="" && produk['diskon'].rupiah>0 && 1>=produk['diskon'].min_qty && 1<=produk['diskon'].max_qty){
                                    // 	console.log('tes_produk', produk);
                                    // 	// console.log('tes_diskon_rupiah', produk['diskon'].rupiah)
                                    // 	// diskon_rupiah = produk['diskon'].rupiah;
                                    // }

                                    temp_cart.push({
                                        id: produk["id"],
                                        nama: produk["nama"],
                                        harga: produk["harga"],
                                        dosis: this.state.dosis,
                                        keterangan: this.state.keterangan,
                                        qty: 1,
                                    });
                                    // temp_label_produk = produk['nama']+' '+harga.toLocaleString('en-US');
                                } else {
                                    const index_cari = temp_cart.findIndex(
                                        (data) => data.id == this.state.barcodeObatResults[0].id
                                    );
                                    if (index_cari == -1) {
                                        let produk = this.state.barcodeObatResults[0];
                                        // let harga = 0;

                                        temp_cart.push({
                                            id: produk["id"],
                                            nama: produk["nama"],
                                            harga: produk["harga"],
                                            dosis: this.state.dosis,
                                            keterangan: this.state.keterangan,
                                            qty: 1,
                                        });
                                        // temp_label_produk = produk['nama']+' '+harga.toLocaleString('en-US');
                                    } else {
                                        let produk = this.state.barcodeObatResults[0];
                                        // let harga = 0;

                                        // temp_label_produk = produk['nama']+' '+harga.toLocaleString('en-US')+' x '+(temp_cart[index_cari]['qty']+1);
                                        temp_cart[index_cari]["qty"] =
                                            temp_cart[index_cari]["qty"] + 1;
                                    }
                                }
                                this.setState(
                                    {
                                        cartObat: temp_cart,
                                        // label_produk: temp_label_produk
                                    },
                                    () => {
                                        // console.log('cart', this.state.cart)
                                    }
                                );
                                var temp_total = 0;
                                this.state.cartObat.map((item) => {
                                    temp_total += item["harga"] * item["qty"];
                                });
                                this.setState({
                                    totalObat: temp_total,
                                    total_finalObat: temp_total,
                                    barcodeTextObat: "",
                                });
                            }
                        );
                        this.resetToAdd();
                    } else {
                        this.setState({
                            barcodeObatIsNotFound: true,
                            barcodeObatResults: null,
                            loadingBarcodeObat: false,
                            barcodeTextObat: "",
                        });
                        message.error({
                            content: "produk tidak ditemukan",
                            duration: 2,
                            key: "toast",
                        });
                        // this.resetToAdd();
                    }
                    // this.barcodeRef.current.val = undefined;
                } else {
                    const errTitle = "error get data";
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg,
                        loadingBarcodeObat: false,
                        barcodeObatIsNotFound: false,
                        barcodeTextObat: "",
                    });
                    message.error({ content: errTitle, duration: 2, key: "toast" });
                    this.resetToAdd();
                }
                this.setState({ loadingProduk: false });
            })
            .catch((response) => {
                console.log("gagal_get_preview", response);
                message.error({
                    content: "gagal request data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
                this.setState({ loadingBarcode: false });
                this.resetToAdd();
            });
    }

    async pilihObat(id) {
        // this.setState({loadingBarcode: true});
        //console.log('master/api/desa/?limit='+limit+'&offset='+offset);
        this.setState({
            loadingAdd: true,
        });

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.produk + "/" + id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    if (data != undefined) {
                        this.setState(
                            {
                                barcodeObatIsNotFound: false,
                                barcodeObatResults: data,
                                loadingBarcodeObat: false,
                            },
                            () => {
                                let temp_cart = this.state.cartObat;
                                // let temp_label_produk = this.state.label_produk;
                                let that = this;
                                if (temp_cart.length == 0) {
                                    let produk = this.state.barcodeObatResults;

                                    temp_cart.push({
                                        id: produk["id"],
                                        nama: produk["nama"],
                                        harga: produk["harga"],
                                        qty: 1,
                                        dosis: this.state.dosis,
                                        keterangan: this.state.keterangan,
                                        dosis_nama: this.state.dosis_nama,
                                        racikan:
                                            this.state.racikan == undefined
                                                ? null
                                                : this.state.racikan,
                                        racikan_nama: this.state.racikan_nama,
                                        aturan_makan: this.state.aturan_makan,
                                        waktu: this.state.waktu
                                    });
                                } else {
                                    const index_cari = temp_cart.findIndex(
                                        (data) => data.id == this.state.barcodeObatResults.id
                                    );
                                    if (this.state.racikan == null) {
                                        //non racik
                                        if (index_cari == -1) {
                                            let produk = this.state.barcodeObatResults;
                                            temp_cart.push({
                                                id: produk["id"],
                                                nama: produk["nama"],
                                                harga: produk["harga"],
                                                qty: 1,
                                                dosis: this.state.dosis,
                                                keterangan: this.state.keterangan,
                                                dosis_nama: this.state.dosis_nama,
                                                racikan:
                                                    this.state.racikan == undefined
                                                        ? null
                                                        : this.state.racikan,
                                                racikan_nama: this.state.racikan_nama,
                                                aturan_makan: this.state.aturan_makan,
                                                waktu: this.state.waktu
                                            });
                                        } else {
                                            let produk = this.state.barcodeObatResults;
                                            temp_cart[index_cari]["qty"] =
                                                temp_cart[index_cari]["qty"] + 1;
                                        }
                                    } else {
                                        //racikan
                                        let produk = this.state.barcodeObatResults;
                                        temp_cart.push({
                                            id: produk["id"],
                                            nama: produk["nama"],
                                            harga: produk["harga"],
                                            qty: 1,
                                            dosis: this.state.dosis,
                                            keterangan: this.state.keterangan,
                                            dosis_nama: this.state.dosis_nama,
                                            racikan:
                                                this.state.racikan == undefined
                                                    ? null
                                                    : this.state.racikan,
                                            racikan_nama: this.state.racikan_nama,
                                            aturan_makan: this.state.aturan_makan,
                                            waktu: this.state.waktu
                                        });
                                    }
                                }
                                this.setState(
                                    {
                                        cartObat: temp_cart,
                                    },
                                    () => {
                                        // console.log('cart', this.state.cart)
                                    }
                                );
                                var temp_total = 0;
                                this.state.cartObat.map((item) => {
                                    temp_total += item["harga"] * item["qty"];
                                });
                                this.setState(
                                    {
                                        totalObat: temp_total,
                                        total_finalObat: temp_total,
                                        barcodeTextObat: "",
                                    },
                                    () => {
                                        this.formRefFoto.current.setFieldsValue({
                                            produks: undefined,
                                        });
                                    }
                                );
                            }
                        );
                    } else {
                        this.setState({
                            barcodeObatIsNotFound: true,
                            barcodeObatResults: null,
                            loadingBarcodeObat: false,
                            barcodeTextObat: "",
                        });
                    }
                    // this.barcodeRef.current.val = undefined;
                    this.setState({
                        loadingAdd: false,
                    });
                    this.resetToAdd();
                } else {
                    const errTitle = "error get data";
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg,
                        loadingBarcodeObat: false,
                        barcodeObatIsNotFound: false,
                        barcodeTextObat: "",
                        loadingAdd: false,
                    });
                    message.error({ content: errTitle, duration: 2, key: "toast" });
                }
                this.setState({ loadingProduk: false });
            })
            .catch((response) => {
                console.log("gagal_get_preview", response);
                message.error({
                    content: "gagal request data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
                this.setState({ loadingBarcode: false });
            });
    }

    removeObat(id, nama, isExisting) {
        Modal.confirm({
            title: "Konfirmasi Hapus?",
            icon: <ExclamationCircleOutlined />,
            content: "yakin menghapus item : " + nama + "?",
            okText: "Ya",
            okType: "danger",
            cancelText: "Tidak",
            onOk: () => this.prosesHapusItem(id, isExisting),
            onCancel() {
                //console.log('Cancel');
            },
        });
    }

    prosesHapusItem(id, isExisting) {
        const temp_cart = this.state.cartObat;
        var index_cari;
        if (isExisting) {
            index_cari = temp_cart.findIndex((data) => data.idx == id);
            this.hapusExisting(id);
        } else {
            index_cari = temp_cart.findIndex((data) => data.id == id);

            temp_cart.splice(index_cari, 1);
            this.setState({
                cartObat: temp_cart,
            });
            var temp_total = 0;
            this.state.cartObat.map((item) => {
                // temp_total += (item['harga']*item['qty']);
                temp_total += parseFloat(item["harga"]) * parseFloat(item["qty"]);
            });
            this.setState({
                totalObat: temp_total,
                total_finalObat: temp_total,
            });
        }
    }

    setQtyObat(e, id) {
        if (e.target.value != undefined && e.target.value != null && e.target.value != '') {
            const temp_cart = this.state.cartObat;
            const index_cari = temp_cart.findIndex((data) => data.id == id);
            if (e.target.value == "0") {
                temp_cart.splice(index_cari, 1);
            } else {
                temp_cart[index_cari]["qty"] = parseFloat(e.target.value);
            }
            this.setState({
                cartObat: temp_cart,
            });
            var temp_total = 0;
            this.state.cartObat.map((item) => {
                // temp_total += (item['harga']*item['qty']);
                temp_total += parseFloat(item["harga"]) * parseFloat(item["qty"]);
            });
            this.setState({
                totalObat: temp_total,
                total_finalObat: temp_total,
            });
        } else {
            const temp_cart = this.state.cartObat;
            const index_cari = temp_cart.findIndex((data) => data.id == id);

            temp_cart[index_cari]["qty"] = "";
            this.setState({
                cartObat: temp_cart,
            });
            var temp_total = 0;
            this.state.cartObat.map((item) => {
                // temp_total += (item['harga']*item['qty']);
                if (item["qty"] != "") {
                    temp_total += parseFloat(item["harga"]) * parseFloat(item["qty"]);
                }
            });
            this.setState({
                totalObat: temp_total,
                total_finalObat: temp_total,
            });
        }
    }

    handleSubmitFoto = (values) => {
        var datas = new FormData();
        for (var key in values) {
            if (values[key] == undefined) {
                datas.append(key, '');
            } else {
                datas.append(key, values[key].toString());
            }
        }
        if (this.state.gambar != null) {
            datas.append('gambar', this.state.gambar, this.state.gambar.name);
        } else {
            datas.append('gambar', '');
        }
        datas.append("transaksi", this.props.transaksi[0].id);

        this.postData(datas);
    };

    async hapusExisting(id) {
        this.setState({
            errTitle: "",
            errMsg: "",
        });

        message.loading({ content: "Memproses...", duration: 0, key: "toast" });

        var that = this;

        this.props
            .ajaxHandler(
                "del",
                configClass.apiUrl.detail_transaksi + id,
                null,
                false,
                true
            )
            .then(() => {
                if (this.props.isSuccess) {
                    message.success({
                        content: "berhasil menghapus item",
                        duration: 2,
                        key: "toast",
                    });

                    const temp_cart = this.state.cartObat;
                    const index_cari = temp_cart.findIndex((data) => data.id == id);

                    temp_cart.splice(index_cari, 1);
                    this.setState({
                        cartObat: temp_cart,
                    });
                    var temp_total = 0;
                    this.state.cartObat.map((item) => {
                        // temp_total += (item['harga']*item['qty']);
                        temp_total += parseFloat(item["harga"]) * parseFloat(item["qty"]);
                    });
                    this.setState({
                        totalObat: temp_total,
                        total_finalObat: temp_total,
                    });
                } else {
                    const errTitle = "gagal menghapus item";
                    message.error({ content: errTitle, duration: 2, key: "toast" });
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg,
                    });
                }
            })
            .catch((response) => {
                console.log("gagal_del", response);
                this.setState({
                    loadingSimpanLayanan: false,
                });
                message.error({
                    content: "kesalahan pengiriman data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
            });
    }

    async postData(datas) {
        this.setState({
            errTitle: "",
            errMsg: "",
            loadingSimpanObat: true,
        });

        message.loading({ content: "Memproses...", duration: 0, key: "toast" });

        var that = this;

        this.props
            .ajaxHandler(
                this.state.method,
                configClass.apiUrl.detail_transaksi,
                datas,
                true,
                true
            )
            .then(() => {
                this.setState({
                    loadingSimpanObat: false,
                });
                if (this.props.isSuccess) {
                    message.success({
                        content: "berhasil menyimpan data",
                        duration: 2,
                        key: "toast",
                    });
                    this.setState({
                        isFinish: true,
                    });
                    var response = this.props.responseMsg;
                    var that = this;
                    this.getData();

                } else {
                    const errTitle = "gagal menyimpan data";
                    message.error({ content: errTitle, duration: 2, key: "toast" });
                    this.setState({
                        errTitle: errTitle,
                        errMsg: this.props.responseMsg,
                    });
                }
            })
            .catch((response) => {
                console.log("gagal_post", response);
                this.setState({
                    loadingSimpanObat: false,
                });
                message.error({
                    content: "kesalahan pengiriman data, coba lagi",
                    duration: 2,
                    key: "toast",
                });
            });
    }

    resetToAdd() {
        this.formRefFoto.current.setFieldsValue({
            barcode: undefined,
            produks: undefined,
        });
        this.setState({
            tempKodeBarcode: null,
            tempIdProduk: null,
        });
    }

    reset() {
        this.setState({
            cartObat: [],
            barcodeObatIsNotFound: false,
            barcodeObatResults: null,
            totalObat: 0,
            total_finalObat: 0,
            barcodeTextObat: undefined,
        });
    }

    render() {
        return (
            <div>
                <Form
                    layout="vertical"
                    name="ffoto"
                    onFinish={this.handleSubmitFoto}
                    size="small"
                    ref={this.formRefFoto}
                    initialValues={{
                        // jenis_layanan: this.state.jenis_layanan,
                    }}
                >
                    <Row>
                        <Col span={24}>

                            <Form.Item
                                label="FOTO"
                                name="gambar"
                                rules={[
                                    {
                                        required: true,
                                        message: 'harus dipilih'
                                    }
                                ]}
                            >
                                <Input
                                    accept="image/png, image/jpeg"
                                    type="file"
                                    placeholder="pilih gambar"
                                    onChange={this.setGambar}
                                />
                            </Form.Item>
                            {(this.state.aksi == 'edit' && this.state.preview_gambar != null &&
                                <img src={this.state.preview_gambar} width="100" height="100" style={{ objectFit: 'cover' }} />
                            )}

                            <Form.Item name="simpan" >
                                <Button
                                    key="btn-simpan-layanan"
                                    loading={this.state.loadingSimpanFoto}
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                >
                                    {!this.state.loadingSimpanFoto && <SaveOutlined />}
                                    Simpan
                                </Button>
                            </Form.Item>

                        </Col>
                        <Col span={24}>RIWAYAT FOTO</Col>
                        <Col span={24}>
                            <Table
                                title={() =>
                                    <Row>
                                        <Col lg={8} sm={24} xs={24}><span className="konten-judul">Total {this.state.pagination.total} record</span></Col>
                                        <Col lg={{ span: 8, offset: 8 }} sm={24} xs={24}>
                                            <Input.Search
                                                size="small"
                                                placeholder="ketikkan pencarian"
                                                onSearch={value => {
                                                    this.setState({
                                                        searchText: value
                                                    }, () => {
                                                        this.getData();
                                                    });
                                                }}
                                                allowClear
                                            />
                                        </Col>
                                    </Row>
                                }
                                bordered
                                columns={this.state.columns}
                                dataSource={this.state.dataSource}
                                loading={this.state.loadingData}
                                scroll={{ x: 240, y: 450 }}
                                size="small"
                                pagination={this.state.pagination}
                                onChange={this.handleTableChange}
                            />


                        </Col>

                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = function (state) {
    return state.configReducers;
};

export default connect(mapStateToProps, {
    initHandler,
    setConfig,
    ajaxViewHandler,
    ajaxHandler,
})(Foto);
